/* maks-hero-slajd: skrypty sekcji przeniesione z pliku sekcji. Uruchamiaja wszystkie
   kopie sekcji na stronie. */
;(function () {
  var init = function (box) {
    if (box.getAttribute('data-hs-init') === '1') return;
    box.setAttribute('data-hs-init', '1');

    var slides = box.querySelectorAll('[data-hs-slide]');
    if (slides.length < 2) return;

    var dots = box.querySelectorAll('[data-hs-dot]');
    var fill = box.querySelector('[data-hs-fill]');
    var stage = box.querySelector('[data-hs-stage]');
    var auto = box.getAttribute('data-autoplay') === '1';
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dur = parseInt(box.getAttribute('data-speed'), 10) || 5000;

    var i = 0;
    var hHover = false;
    var hView = false;
    var hTab = document.hidden;
    var timer = null;
    var startAt = 0;
    var left = dur;

    var held = function () { return hHover || hView || hTab; };
    var moze = function () { return auto && !calm.matches; };

    var paint = function () {
      for (var k = 0; k < slides.length; k++) {
        var on = k === i;
        slides[k].classList.toggle('is-active', on);
        slides[k].setAttribute('aria-hidden', on ? 'false' : 'true');
        var link = slides[k].querySelector('a.hs-link');
        if (link) link.setAttribute('tabindex', on ? '0' : '-1');
        if (dots[k]) {
          dots[k].classList.toggle('is-on', on);
          dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
    };

    var stopTimer = function () {
      if (timer) { clearTimeout(timer); timer = null; }
    };

    var runTimer = function () {
      stopTimer();
      if (!moze() || held()) return;
      startAt = Date.now();
      timer = setTimeout(function () { timer = null; go(i + 1); }, left);
    };

    var pauseTimer = function () {
      if (timer) {
        left = Math.max(150, left - (Date.now() - startAt));
        stopTimer();
      }
    };

    var bar = function () {
      if (!fill) return;
      box.classList.remove('is-run');
      void fill.offsetWidth;
      if (moze() && !held()) box.classList.add('is-run');
    };

    var go = function (to) {
      i = (to + slides.length) % slides.length;
      if (window.HS_ODSLON) window.HS_ODSLON(slides[i]);
      left = dur;
      paint();
      bar();
      box.classList.toggle('is-hold', held());
      runTimer();
    };

    var sync = function () {
      var h = held();
      box.classList.toggle('is-hold', h);
      if (h) { pauseTimer(); } else { runTimer(); }
    };

    var prev = box.querySelector('[data-hs-prev]');
    var next = box.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    for (var d = 0; d < dots.length; d++) {
      (function (n) { dots[n].addEventListener('click', function () { go(n); }); }(d));
    }

    box.addEventListener('mouseenter', function () { hHover = true; sync(); });
    box.addEventListener('mouseleave', function () { hHover = false; sync(); });
    box.addEventListener('focusin', function () { hHover = true; sync(); });
    box.addEventListener('focusout', function () { hHover = false; sync(); });
    document.addEventListener('visibilitychange', function () { hTab = document.hidden; sync(); });

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        hView = !entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 });
      io.observe(box);
    }

    if (stage) {
      var x0 = null;
      var y0 = null;
      stage.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX;
        y0 = e.changedTouches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
        y0 = null;
      }, { passive: true });
    }

    paint();
    bar();
    runTimer();
  };

  var boot = function (scope) {
    var nodes = (scope || document).querySelectorAll('[data-hs]');
    for (var n = 0; n < nodes.length; n++) init(nodes[n]);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
;/* Zdjecia slajdow poza pierwszym maja adresy w data-hs-src / data-hs-srcset, zeby
   przy wczytaniu nie zabieraly lacza zdjeciu pierwszego slajdu. Podpinamy je po
   zaladowaniu strony (najpozniej po 4 s) albo tuz przed przejsciem na dany slajd. */
(function () {
  var odslon = function (scope) {
    var n = (scope || document).querySelectorAll('[data-hs-srcset], [data-hs-src]');
    for (var k = 0; k < n.length; k++) {
      var el = n[k];
      var ss = el.getAttribute('data-hs-srcset');
      if (ss) { el.setAttribute('srcset', ss); el.removeAttribute('data-hs-srcset'); }
      var u = el.getAttribute('data-hs-src');
      if (u) { el.setAttribute('src', u); el.removeAttribute('data-hs-src'); }
    }
  };
  window.HS_ODSLON = odslon;
  var wszystko = function () { odslon(document); };
  if (document.readyState === 'complete') wszystko();
  else window.addEventListener('load', wszystko, { once: true });
  setTimeout(wszystko, 4000);
  document.addEventListener('shopify:section:load', function (e) { odslon(e.target); });
})();
